<script lang="ts">
  import { mloc, loc } from "module/utils";
  import {
    directory,
    disabled,
    documents,
    packs,
    type IndexingEntry,
  } from "module/store/IndexingDisabledStore";
  import { ModuleSetting } from "module/store/ModuleSettings";
  import { stores } from "module/store/SettingsStore";

  import IndexingRow from "./IndexingRow.svelte";
  import NiceButton from "../NiceButton.svelte";

  let { active }: { active: boolean } = $props();
  let filter = $state("");
  let showFolders = stores[ModuleSetting.SHOW_FOLDERS_IN_INDEXING_TAB];

  const filterRows = (filter: string, rows: IndexingEntry[]) =>
    rows.filter(
      (row) =>
        row.title.toLowerCase().includes(filter.toLowerCase()) ||
        row.subTitle?.toLowerCase().includes(filter.toLowerCase())
    );

  const change = (row: IndexingEntry) => (event: CustomEvent) => {
    if (event.detail.role) {
      disabled.toggleRole(
        row.type,
        row.id,
        event.detail.role,
        event.detail.disabled
      );
    } else {
      disabled.toggleAll(row.type, row.id, event.detail.disabled);
    }
  };

  function selectAll() {
    filterRows(filter, $packs).forEach((row) =>
      change(row)(new CustomEvent("", { detail: { disabled: false } }))
    );
  }

  function deselectAll() {
    filterRows(filter, $packs).forEach((row) =>
      change(row)(new CustomEvent("", { detail: { disabled: true } }))
    );
  }
</script>

<div class="indexingtab standard-form" class:hidden={!active} role="tabpanel">
  <p class="notes">
    {mloc("IndexingSettingsIntroduction")}
  </p>
  <header class="table-header flexrow">
    <span class="index">
      <input
        class="filter-input"
        type="text"
        placeholder={mloc("FilterEditorOptionFilter")}
        bind:value={filter}
      />
    </span>
    <span>{loc("USER.RolePlayer")}</span>
    <span>{loc("USER.RoleTrusted")}</span>
    <span>{loc("USER.RoleAssistant")}</span>
    <span>{loc("USER.RoleGamemaster")}</span>
  </header>

  <div class="indexing-list">
    <h3>{loc("COMPENDIUM.Type")}</h3>
    {#each filterRows(filter, $documents) as row (row.id)}
      <IndexingRow {row} on:change={change(row)} />
    {:else}
      <span class="notes"
        >{mloc("IndexingSettingsNoMatchType", { filter })}</span
      >
    {/each}
    <h3>
      {mloc("FilterEditorDirectory")}
      <label class="inline-checkbox">
        <input
          type="checkbox"
          name="showFolders"
          id="showFolders"
          bind:checked={$showFolders}
        />
        {mloc("IndexingSettingsShowFolders")}
      </label>
    </h3>

    {#each filterRows(filter, $directory.slice(0, 1)) as row (row.id)}
      <IndexingRow {row} on:change={change(row)} />
    {/each}
    {#if $showFolders}
      {#each filterRows(filter, $directory.slice(1)) as row (row.id)}
        <IndexingRow {row} on:change={change(row)} />
      {/each}
    {/if}
    <h3>{loc("SIDEBAR.TabCompendium")}</h3>
    <div class="form-group">
      <NiceButton on:click={selectAll}
        >{mloc("IndexingSettingsSelectAll")}</NiceButton
      >
      <NiceButton on:click={deselectAll}
        >{mloc("IndexingSettingsDeselectAll")}</NiceButton
      >
    </div>
    {#each filterRows(filter, $packs) as row (row.id)}
      <IndexingRow {row} on:change={change(row)} />
    {:else}
      <span class="notes"
        >{mloc("IndexingSettingsNoMatchCompendium", { filter })}</span
      >
    {/each}
  </div>
</div>

<style>
  .indexingtab {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 0;
  }

  .hidden {
    display: none;
  }
  .indexingtab > * {
    flex: unset;
  }

  .filter-input {
    color: inherit;
    font-weight: normal;
  }

  .filter-input::placeholder {
    color: inherit;
    opacity: 0.6;
  }

  .indexing-list {
    overflow-y: auto;
    overflow-x: hidden;
    height: 500px;
    scrollbar-width: thin;
    flex: 1;
  }

  .index {
    flex: 0 0 45%;
    font-weight: bold;
    padding: 0 1em;
  }

  header.table-header {
    background: #2229;
    line-height: 2em;
    text-align: center;
    color: #f0f0e0;
    font-weight: bold;
    text-shadow: 1px 1px #000d;
    box-shadow: 0 2px 2px #0006;
    position: relative;
    z-index: 2;
  }

  .indexing-list h3 {
    color: #f0f0e0;
    background: rgba(0, 0, 0, 0.5);
    border: none;
    text-shadow: 1px 1px #000d;
    padding: 0.2em;
    font-size: 120%;
    margin: 0;
  }
  .inline-checkbox {
    opacity: 0.8;
    font-size: 80%;
    display: inline-flex;
    align-items: center;
  }

  p.notes {
    margin: 0.6em;
  }
</style>
